export default "__VITE_ASSET__DNdghGv7__"